module.exports = __webpack_public_path__ + "static/media/line_selected.328deb5e.svg";